import React from 'react';
import axios from 'axios';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext.js';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RadarIcon from '@mui/icons-material/Radar';
import MessageSnackBar from './MessageSnackBar.js';

import SimpleTitleGrid from './SimpleTitleGrid.js';
import { 
    Button, 
    Grid,
    Paper, 
  } from '@mui/material';
import { width } from '@mui/system';



const CycleCountsMetrics = (props) => {
    //SECTION USER CONTEXT and HEADERS
    const userData = useContext(UserContext);
    const storedHeaders = sessionStorage.getItem('headers');
    const headers = storedHeaders ? JSON.parse(storedHeaders) : {};
    // !SECTION

    //SECTION Message Bar Controls
      const [ messageBarMessage, setMessageBarMessage ] = React.useState('');
      const [ messageBarOpen, setMessageBarOpen ] = React.useState(false);
      const [ messageSeverity, setMessageSeverity ] = React.useState('success');
      const handleMessageBarClosing = () => {
        setMessageBarOpen(false);
      };
      //!SECTION

    //SECTION Component Controls
    const itemMessage = 'Cycle Counts Metrics';
    const toggleItems = () => {
      if (viewItems){
          setViewItems(false);
          setViewItemsMessage(`${itemMessage}`);
          // console.log("user data", userData.name)
      }else{
          // getWarehouseList(userData.email)
          setViewItems(true);
          setViewItemsMessage(`Hide ${itemMessage}`);
      };
  } ;
    const [ viewItems, setViewItems ] = React.useState(false);
    const [ viewItemsMessage, setViewItemsMessage ] = React.useState(`View ${itemMessage}`);

    //!SECTION

  //SECTION - DataGrid Admin Metrics Controls

  const inventoryVisibleColumns = {
    id: false,
    serialNum: false,
    };
  const sortModel = {};
  const pinnedColumns = [];
  const visibleColumns = {
    id: false,
  };
  // const inventoryVisibleColumns = {
  //   id: false,
  //   serialNum: false,
  //   };
  // const inventorySortModel = { field: "arrivedAt" ,sort: "desc" };
  // const inventoryPinnedColumns = ["warehouseName", "warehouseNumber"];


  const [ gridData, setGridData ] = React.useState([]);

  const gridColumns =  [
    // {field: 'id', hidden: true},
    {field: 'id', headerName: 'Id',  editable: false, headerAlign: 'center', align: 'center',  type:'number', width: 150},
    {field: 'locationName', headerName: 'Warehouse Name', headerAlign: 'center', align: 'center',  editable: false, width: 250},
    {field: 'warehouseNumber', headerName: 'Warehouse Number',  headerAlign: 'center', align: 'center', editable: false, width: 150},
    {field: 'CreatedBy', headerName: 'Cycle Count Creator',  headerAlign: 'center', align: 'center', editable: false, width: 250},
    {field: 'CreatedAt', headerName: 'Cycle Count Date',  headerAlign: 'center', align: 'center', editable: false, width: 150},
    {field: 'Beginning Inventory', headerName: 'Beginning Inventory',  headerAlign: 'center', align: 'center', editable: false, width: 150},
    {field: 'correctScans', headerName: 'Correct Scans',  headerAlign: 'center', align: 'center', editable: false, width: 125},
    {field: 'foundDiscrepancies', headerName: 'Found Discrepancies',  headerAlign: 'center', align: 'center', editable: false, width: 175},
    {field: 'missingDiscrepancies', headerName: 'Missing Discrepancies',  headerAlign: 'center', align: 'center', editable: false, width: 175},
    {field: 'movedDiscrepancies', headerName: 'Moved Discrepancies',  headerAlign: 'center', align: 'center', editable: false, width: 175},
    {field: 'Accuracy', headerName: 'Shelf Accuracy',  headerAlign: 'center', align: 'center', editable: false, width: 150},
    {field: 'Warehouse Accuracy', headerName: 'Warehouse Accuracy',  headerAlign: 'center', align: 'center', editable: false, width: 150},
    ]

    //!SECTION



    //SECTION - Data Fetching 

    React.useEffect(() => {
      getCycleCountsStats();
    }, []);


    const getCycleCountsStats = async (user) => {
        var parameters = { accountcode: userData.accountCode}; 
        await axios
        .get(
            `/Metrics/allcyclecounts`,
            { headers: headers, params: parameters }
            )
            .then(function async(response) {
              // console.log("current metrics", response.data.message)
              setGridData(response.data.message)
            })
            .catch(function (error) {
            if (error.response.status === 401) {
                alert ("Your session has expired. Please login again.");
    
            }
            if (error.response.status !== 401) {
                setMessageBarMessage(`${error.response.data.detail}  Something went wrong. Contact info@edonconnect.tech for help.`);
                setMessageBarOpen(true);
                setMessageSeverity("error") // error: red, warning: orange, information: blue, success: green
            }
            })
        };

    //SECTION - DNI by location



  return (  

      <>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{ alignContent: "center", border: 0 }}
      >
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
        >
          <Button 
          onClick={toggleItems}
          startIcon={<RadarIcon size="large" />}
          >
            {" "}
            {viewItemsMessage}
          </Button>

          {/* Component Items */}
          {viewItems &&
          <>
          <MessageSnackBar messageBarMessage={messageBarMessage} messageBarOpen={messageBarOpen} handleMessageBarClosing={handleMessageBarClosing} messageSeverity={messageSeverity} /> 
          
          {/* <Grid container direction="row" marginTop={5} marginBottom={5} sx={{justifyContent: "space-between", border:1, borderStyle: 'dotted', borderRadius: '5px'  }}> */}
          <Grid
            container
            marginTop={5}
            sx={{
              justifyContent: "space-between",
              alignContent: "flex-start",
              p: 1,
              border: 0,
              borderStyle: "dotted",
              borderRadius: "5px",
              overflow: 'hidden'
            }}
          >

          <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{  
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            border: 1,
            borderStyle: "dotted",
            borderRadius: "5px",

            }}
          >
            <SimpleTitleGrid 
            gridColumns={gridColumns}
            gridData={gridData}
            gridTitle={"Cycle Count Metrics"}
            visibleColumns={visibleColumns}
            sortModel = { sortModel }
            pinnedColumns={ pinnedColumns}
            />
          </Grid>      


          </Grid>
        </>
    }
        </Paper>
      </Grid>
  </>


  );
};
export default CycleCountsMetrics;